import { SVGAttributes } from 'react'

const SearchIcon = (props: SVGAttributes<SVGElement>) => (
    <svg {...props} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.4088 0C15.6057 0 19 3.50246 19 7.8133C19 12.1241 15.6057 15.6266 11.4088 15.6266C9.73627 15.6266 8.19116 15.0703 6.93757 14.1283L1.81908 19.663C1.42195 20.0924 0.756427 20.1144 0.332594 19.712C-0.0912386 19.3097 -0.112884 18.6354 0.284248 18.206L5.43584 12.6359C4.42195 11.3072 3.81766 9.63219 3.81766 7.8133C3.81766 3.50246 7.21199 0 11.4088 0ZM11.4088 2.1309C8.38234 2.1309 5.92099 4.67067 5.92099 7.8133C5.92099 10.9559 8.38234 13.4957 11.4088 13.4957C14.4353 13.4957 16.8967 10.9559 16.8967 7.8133C16.8967 4.67067 14.4353 2.1309 11.4088 2.1309Z"
            fill={props.color}
        />
    </svg>
)

export default SearchIcon
